export const SiteErrors = {
  name: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer le nom du chantier."
  },
  address: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer l'adresse du chantier."
  },
  dateStart: {
    undefined: "",
    must_not_be_null: "Veuillez indiquer la date début du chantier."
  }
}

export const EventErrors = {
  name: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer le nom de l'événement."
  },
  date: {
    undefined: "",
    must_not_be_null: "Veuillez indiquer la date de l'événement."
  }
}

export const ProgressReportErrors = {
  date: {
    undefined: "",
    must_not_be_null: "Veuillez indiquer la date du relevé."
  }
}

export const PrestationErrors = {
  description: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer la description de la prestation."
  },
  progressReport: {
    undefined: ""
  },
  date: {
    undefined: "",
    must_not_be_null: "Veuillez indiquer la date de la prestation."
  }
}

export const ContactErrors = {
  name: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer le nom du contact."
  },
  email: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer une adresse email."
  },
  phone: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer un téléphone."
  },
  address: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer une adresse."
  },
}

export const PurchaseErrors = {
  name: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer le nom du matériel à acheter."
  },
  quantity: {
    must_not_be_null: "Veuillez indiquer la quantité."
  }
}

export const MemoErrors = {
  name: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer le nom du mémo."
  },
}

export const VehiculeErrors = {
  name: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer le nom du véhicule."
  },
}

export const FolderErrors = {
  name: {
    undefined: "",
    must_not_be_blank: "Veuillez indiquer le nom du dossier."
  },
}